<template>
  <div>
    <div class="week_record_box">
      <div class="week_record_title">写手周结表</div>
      <el-date-picker
        v-model="timeData"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        @change="timeChange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>

    <!-- 筛选 -->
    <div class="daySheet_box">
      <div style="margin-bottom: 10px;">
        <el-input
          placeholder="请输入内容"
          v-model="searchTxt"
          class="input-with-select"
        >
          <el-select
            v-model="select"
            slot="prepend"
            @change="changeSelect"
            placeholder="请选择"
          >
            <el-option label="写手昵称" value="1"></el-option>
            <el-option label="书名" value="2"></el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchBtn"
          ></el-button>
        </el-input>
      </div>
      <div class="right_btn_box">
        <div class="week_record_btn">
          <div class="book_btn" @click="handleData()">
            <i class="iconfont icon-xiazai"></i>
            导出Excel
          </div>
        </div>
      </div>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table height="550" :data="dataShow" border @sort-change="SortChange">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          width="200"
        ></el-table-column>
        <el-table-column
          property="writer_name"
          label="写手姓名"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="alipay_account"
          label="写手支付宝"
          align="center"
          sortable
          width="120"
        ></el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          align="center"
          sortable
          width="160"
        ></el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="writer_cost"
          label="写手价格"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          property="each_chapter_num"
          label="每章字数"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="word_number"
          label="本周总字数"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="fee"
          label="应结算金额"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="w_fee"
          label="未结算金额"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="over_deposit_money"
          label="暂压金额"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="advance_fee"
          label="预支金额"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column
          property="status"
          label="任务状态"
          align="center"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '-1'
                  ? 'danger'
                  : scope.row.status == '0'
                  ? 'info'
                  : scope.row.status == '1'
                  ? ''
                  : 'success'
              "
            >
              <div
                class="tag_circle"
                :class="[
                  scope.row.status == '-1'
                    ? 'tag_red'
                    : scope.row.status == '0'
                    ? 'tag_gray'
                    : scope.row.status == '1'
                    ? 'tag_blue'
                    : 'tag_green'
                ]"
              ></div>
              {{
                scope.row.status == "-1"
                  ? "已停止"
                  : scope.row.status == "0"
                  ? "未开始"
                  : scope.row.status == "1"
                  ? "进行中"
                  : "已完结"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          property="start_time"
          label="本周开始时间"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          property="end_time"
          label="本周结束时间"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="110"
        >
          <template slot-scope="scope">
            <div @click="detailtDialog(scope.row)" class="reject_record_btn">
              <i class="iconfont icon-zongcejieguochakan"></i>
              查看详情
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 选择字段弹窗 -->
      <el-dialog
        :visible.sync="selectDialogVisible"
        title="选择下载字段"
        width="20%"
        top="2vh"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          class="check_all_item"
          >全选</el-checkbox
        >
        <el-checkbox-group
          v-model="MainChecked"
          @change="handleCheckedCitiesChange"
          class="check_box"
        >
          <el-checkbox
            v-for="obj in MainList"
            :label="obj.val"
            :key="obj.val"
            class="check_item"
            >{{ obj.name }}</el-checkbox
          >
        </el-checkbox-group>

        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog_btn"
            round
            type="primary"
            @click="downloadExcel()"
            >确认</el-button
          >
          <el-button
            class="dialog_btn"
            round
            @click="selectDialogVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>

      <!-- 查看详情弹窗 -->
      <el-dialog
        :visible.sync="detailDialogVisible"
        title="周结表详情"
        @close="cancelDialog"
        width="90%"
      >
        <el-table :data="dataShowDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>

          <el-table-column
            property="writer_nickname"
            sortable
            label="写手昵称"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="connectionessay_name"
            sortable
            label="书名"
            width="260"
            align="center"
          ></el-table-column>
          <el-table-column
            property="writer_name"
            sortable
            label="写手姓名"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="alipay_account"
            sortable
            label="写手支付宝"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="start_chapters"
            sortable
            label="开始章节"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="end_chapters"
            sortable
            label="结束章节"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="writer_cost"
            sortable
            label="给写手千字价格"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            property="each_chapter_num"
            sortable
            label="每章字数"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="number_chapters"
            sortable
            label="章节数"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="word_number"
            sortable
            label="总字数"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="frequency"
            sortable
            label="日结第几天"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="settlement_type"
            sortable
            label="日周结"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.settlement_type == '2' ? '' : 'warning'">
                {{ scope.row.settlement_type == "2" ? "周结" : "日结" }}
              </el-tag>
            </template></el-table-column
          >
          <el-table-column
            property="is_settle"
            sortable
            label="结算状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_settle == '0' ? 'info' : 'success'">
                {{ scope.row.is_settle == "0" ? "未结算" : "已结算" }}
              </el-tag>
            </template></el-table-column
          >

          <el-table-column
            property="status"
            sortable
            label="是否通过"
            width="140"
            align="center"
            ><template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status == '0'
                    ? ' '
                    : scope.row.status == '1'
                    ? 'success'
                    : 'danger'
                "
              >
                {{
                  scope.row.status == "0"
                    ? "审查中"
                    : scope.row.status == "1"
                    ? "通过"
                    : "驳回"
                }}
              </el-tag>
            </template></el-table-column
          >
          <el-table-column
            property="fee"
            sortable
            label="应收稿费"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="deposit_money"
            sortable
            label="压稿"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="advance_fee"
            label="预支金额"
            align="center"
            sortable
            width="110"
          >
          </el-table-column>
          <el-table-column
            property="w_fee"
            sortable
            label="未结算金额"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column
            property="createtime"
            sortable
            label="创建时间"
            width="250"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeDialog"
          @current-change="handleCurrentChangeDialog"
          :current-page="currentPageDialog"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDialog"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDialog"
        >
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  connectionrecord_history_week_list,
  connectionrecord_history_week_list_week,
  connectionrecord_history_week_list_week_excel
} from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      weekSheetList: [], //周结表列表
      weekSheetDeyail: [], //详情列表
      detailDialogVisible: false, //详情弹窗
      selectDialogVisible: false, //字段下载筛选
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      dataShowDialog: [], //弹窗数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      dataShowDialog: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      searchTxt: "", //搜索内容
      select: "", //搜索的筛选
      selectId: "", //筛选项的id
      timeData: [], //时间筛选
      filterTime: "", //筛选时间
      checkAll: false,
      sortValue: "", //排序的字段名
      sortOrder: "", //升序、降序
      MainChecked: [], //选中的下载字段
      MainList: [
        { name: "书名", val: "connectionessay_name" },
        { name: "写手昵称", val: "writer_nickname" },
        { name: "写手姓名", val: "writer_name" },
        { name: "写手支付宝", val: "alipay_account" },
        { name: "开始章节", val: "start_chapters" },
        { name: "结束章节", val: "end_chapters" },
        { name: "写手价格", val: "writer_cost" },
        { name: "每章字数", val: "each_chapter_num" },
        { name: "本周总字数", val: "word_number" },
        { name: "应结算金额", val: "fee" },
        { name: "未结算金额", val: "w_fee" },
        { name: "暂压金额", val: "over_deposit_money" },
        { name: "预支金额", val: "advance_fee" },
        { name: "任务状态", val: "is_task" },
        { name: "创建时间", val: "createtime" },
        { name: "本周开始时间", val: "start_time" },
        { name: "本周结束时间", val: "end_time" }
      ],

      isIndeterminate: false,
      // 这里一定要将首次点击的初始值作为第一个，否则首次将无法选中第一个参数
      linkageval: "",
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getWeekSheetList();
  },
  methods: {
    // 获取写手日结表
    getWeekSheetList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };
      connectionrecord_history_week_list_week(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.weekSheetList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    SortChange(column) {
      var that = this;
      that.sortValue = column.prop;
      that.sortOrder = column.order;
    },
    // 选择下载的字段
    handleData() {
      var that = this;
      that.selectDialogVisible = true;
      this.handleCheckAllChange(true);
    },
    // 导出Excel表格
    downloadExcel() {
      var that = this;
      var connectionessay_name = "";
      var writer_nickname = "";

      if (that.selectId == 1) {
        writer_nickname = that.searchTxt;
      } else {
        connectionessay_name = that.searchTxt;
      }

      let obj = {
        departmentuser_id: that.writerId,
        x_field: this.MainChecked.join(","),
        createtime: that.filterTime,
        sort: that.sortValue,
        order: that.sortOrder,
        connectionessay_name: connectionessay_name, //书名
        writer_nickname: writer_nickname //写手昵称
      };
      connectionrecord_history_week_list_week_excel(obj)
        .then(res => {
          const file_url = res.data.data;
          const link = document.createElement("a");
          // let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          const fileName = "写手周结表.xls";
          // link.href = URL.createObjectURL(blob);
          link.href = file_url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link);
          that.selectDialogVisible = false;
        })
        .catch(error => {
          this.$message({
            message: "导出失败",
            type: "success",
            duration: 3000
          });
        });
    },

    //  记录用户的点击项，当点击项发生改变时触发方法修改全选状态
    linkage(val) {
      this.linkageval = val;
      this.handleCheckedCitiesChange();
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      // 触发了全选按钮，如果选中为true就返回所有内容，否则返回空数组
      this.checkAll = val;

      this.MainChecked = val ? this.MainList.map(item => item.val) : [];
      // 如果全选中或全未选都取消-横杠样式
    },
    handleCheckedCitiesChange() {
      // 触发了单个按钮，如果选中按钮数>0且<按钮总数则显示isIndeterminate样式
      let allCount = this.MainList.length;
      let checkCount = this.MainChecked.length;
      //   console.log(this.MainChecked, this.OtherChecked, 'checkCount', 111111)
      this.isIndeterminate =
        checkCount > 0 && checkCount < allCount ? true : false;
      // 如果选中个数=总数，则全选框状态为选中
      this.checkAll = allCount === checkCount ? true : false;
    },
    // 查看详情弹窗
    detailtDialog(val) {
      var that = this;
      that.detailDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: val.connectionessay_id,
        writer_expand_id: val.writer_expand_id,
        start_time: val.start_time,
        end_time: val.end_time,
        page: 1,
        page_index: 10
      };
      connectionrecord_history_week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.weekSheetDeyail = res.data.data;
          that.calcPageDataDialog();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 搜索的筛选
    changeSelect(val) {
      var that = this;
      that.selectId = val;
    },
    // 搜索按钮
    searchBtn() {
      var that = this;
      var obj;
      if (that.selectId == 1) {
        //根据金主昵称
        obj = {
          departmentuser_id: that.writerId,
          writer_nickname: that.searchTxt, //金主昵称
          createtime: that.filterTime,
          page: 1,
          page_index: 10
        };
      } else {
        obj = {
          departmentuser_id: that.writerId,
          connectionessay_name: that.searchTxt, //书名
          createtime: that.filterTime,
          page: 1,
          page_index: 10
        };
      }
      console.log("obj", obj);
      connectionrecord_history_week_list_week(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.weekSheetList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 时间段筛选
    timeChange(val) {
      var that = this;
      var day_start = val[0];
      var day_end = val[1];
      that.filterTime = day_start + " - " + day_end;
      that.searchBtn();
    },

    cancelDialog() {
      this.goSearch(0);
    },
    calcPageData() {
      if (this.weekSheetList.length > 1) {
        this.pageNum =
          Math.ceil(this.weekSheetList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.weekSheetList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }

      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    calcPageDataDialog() {
      if (this.weekSheetDeyail.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.weekSheetDeyail.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.weekSheetDeyail.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }

      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.week_record_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #ffffff;
  border: 1px solid #e4e9f1;
}
.week_record_box .el-form-item {
  margin: 10px 0px;
}
.week_record_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;

  padding: 15px;
}
.task_box {
  margin: 0px 15px;
}
.record_btn {
  /* width: 200px; */
  height: 25px;
  text-align: center;
  line-height: 6px;
  background: #f3f8ff;
  color: #157df8;
}
.sea_icon {
  font-size: 12px;
}

.task_filter_form {
  width: 96%;
  height: 100px;
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.daySheet_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 10px 0px 15px;
}
.daySheet_box .el-form-item {
  margin-bottom: 10px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}

.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  width: 96%;
  height: 100px;
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 5px;
  display: inline-block;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.tag_red {
  background: #f56c6c;
}
.tag_blue {
  background: #409eff;
}
.tag_green {
  background: #67c23a;
}
.tag_gray {
  background: #909399;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.daySheet_box .el-select {
  width: 130px;
}
.reject_record_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
}
.reject_record_btn i {
  font-size: 12px;
}
.week_record_btn {
  margin-left: 15px;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  color: #157df8;
  font-size: 14px;
  margin-right: 5px;
}
.book_btn i {
  font-size: 14px;
}
.check_box {
  display: flex;
  flex-direction: column;
}
.check_item {
  height: 40px;
}
.check_all_item {
  height: 40px;
  font-size: 20px;
  color: #304265;
  font-weight: bolder;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterWeekSheet.vue